import { MAX_SINGLE_MESSAGE_SIZE } from '../constants/value-constants';
export function chunkMessages(str) {
    const numChunks = Math.ceil(str.length / MAX_SINGLE_MESSAGE_SIZE);
    const chunks = new Array(numChunks);
    for (let i = 0, index = 0; index < str.length; i++) {
        chunks[i] = str.slice(index, (index += MAX_SINGLE_MESSAGE_SIZE));
    }
    return chunks;
}
//# sourceMappingURL=chunk-messages.js.map